import { type RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';

import { GlobalState } from './global';
import { AdminRoutes } from './modules/admin/routes';
import Launcher from './modules/core/launcher.vue';
import LoginSso from './modules/core/login/f-sso.vue';
import { CRMRoutes } from './modules/crm/routes';
import Desktop from './modules/desktop/desktop.vue';
import { DesktopRoutes } from './modules/desktop/routes';
import { DisplayRoutes } from './modules/display/routes';
import { FormsRoutes } from './modules/forms/routes';
import { InventoryRoutes } from './modules/inventory/routes';
import { ItRoutes } from './modules/it/routes';
import { SalesRoutes } from './modules/sales/routes';
import { TalkRoutes } from './modules/talk/routes';
import { wrapRuntimeImport } from './shared/helpers/async.helpers';
import { makePermissionMeta } from './shared/helpers/permissions.helpers';

declare module 'vue-router' {
    interface RouteMeta {
        public?: boolean;
        admin?: boolean;
        app?: string; // use makePermissionMeta
        feature?: string | (() => string);
    }
}

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        component: Launcher
    },
    {
        path: '/zd',
        component: Desktop,
        children: DesktopRoutes
    },
    {
        path: '/admin',
        component: wrapRuntimeImport(() => import('./modules/admin/admin.vue')),
        children: AdminRoutes
    },
    {
        path: '/crm',
        component: wrapRuntimeImport(() => import('./modules/crm/crm.vue')),
        children: CRMRoutes
    },
    {
        path: '/display',
        component: wrapRuntimeImport(() => import('./modules/display/display.vue')),
        children: DisplayRoutes
    },
    {
        path: '/forms',
        component: wrapRuntimeImport(() => import('./modules/forms/forms.vue')),
        children: FormsRoutes
    },
    {
        path: '/inventory',
        component: wrapRuntimeImport(() => import('./modules/inventory/inventory.vue')),
        children: InventoryRoutes
    },
    {
        path: '/it',
        component: wrapRuntimeImport(() => import('./modules/it/it.vue')),
        children: ItRoutes
    },
    {
        path: '/sales',
        component: wrapRuntimeImport(() => import('./modules/sales/sales.vue')),
        children: SalesRoutes
    },
    {
        name: 'talk',
        path: '/talk',
        component: wrapRuntimeImport(() => import('./modules/talk/talk.vue')),
        meta: makePermissionMeta('talk'),
        children: TalkRoutes
    },

    {
        name: 'login:sso',
        path: '/login/sso',
        component: LoginSso,
        meta: { public: true }
    },
    {
        name: 'login:callback',
        path: '/login/callback',
        component: LoginSso,
        meta: { public: true }
    }
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
});
GlobalState.router = router;

export default router;
